// extracted by css-extract-rspack-plugin
export default {"textBox":"KeywordSearchBox__textBox--vvBO2","textBoxWrap":"KeywordSearchBox__textBoxWrap--OfjLG","icon":"KeywordSearchBox__icon--oyZDi"};